export const localizationRu = {
  appbar: {
    downloadApk: 'Скачать приложение Android',
  },
  main: 'Главная',
  addIcon: 'Добавить иконку',
  removeIcon: 'Удалить иконку',
  vectorIconPicker: {
    title: 'Выбрать иконку',
    search: 'Поиск иконок...',
    size: 'Размер иконки',
    library: 'Библиотека',
    category: 'Категория',
    select: 'Выбрать',
    clear: 'Очистить',
    noIcons: 'Иконки не найдены',
    libraries: {
      all: 'Все библиотеки',
      fontAwesome5: 'FontAwesome 5',
      materialDesign: 'Material Design',
      materialIcons: 'Material Icons',
    },
    categories: {
      all: 'Все категории',
      AirsideOperations: 'Аэродромные операции',
      AircraftMaintenance: 'Техническое обслуживание',
      PassengerProcessing: 'Обработка пассажиров',
      GroundTransport: 'Наземный транспорт',
      TerminalServices: 'Сервисы терминала',
      SafetySecurity: 'Безопасность и охрана',
      NavigationWeather: 'Навигация и погода',
      LogisticsSupport: 'Логистика и поддержка',
      HospitalityRetail: 'Гостеприимство и торговля',
      Other: 'Другое',
    },
  },
}
